import { AssetCaseAttributes } from '@/types'
import { UpdateAssetCaseMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditAssetCaseQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type AssetCase = EditAssetCaseQuery['assetCases']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<UpdateAssetCaseMutation, AssetCaseAttributes, EditAssetCaseQuery, AssetCase>({
    id,
    initializer: ac => ({
      description: ac.description || '',
      height: ac.height || 0,
      length: ac.length || 0,
      warehouseId: ac.warehouse?.id || '',
      weight: ac.weight || 0,
      width: ac.width || 0,
    }),
    query: EditQuery,
    queryKey: 'assetCases',
    mutation: UpdateMutation,
    resultKey: 'updateAssetCase'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }
          { formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' }) }
          { formBuilder.buildField({ name: 'Width of empty case', field: 'weight', type: 'weight' }) }
        </div>
        <div className="grid grid-cols-3 gap-6">
          { formBuilder.buildField({
            name: 'Length (including wheels and handles)',
            field: 'length',
            type: 'integer'
          }) }
          { formBuilder.buildField({
            name: 'Width (including wheels and handles)',
            field: 'width',
            type: 'integer'
          }) }
          { formBuilder.buildField({
            name: 'Height (including wheels and handles)',
            field: 'height',
            type: 'integer'
          }) }
        </div>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
